// Helpers for getting and setting cookies.
// Gets a cookie.
var getCookie = function (cookieName) {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var val = ca[i].replace(/^ +/g, '').split('=');
        if (val[0] === cookieName)
            return val[1];
    }
    return '';
};
// Sets a cookie.
var setCookie = function (cookieName, value, expireDays) {
    var d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    document.cookie = "".concat(cookieName, "=").concat(value, ";path=/;expires=").concat(d.toUTCString(), ";");
};
export { getCookie, setCookie };
